const scrollToTop = (behavior?: 'smooth' | 'auto') =>
  window.scrollTo({ top: 0, behavior })

export default scrollToTop
